import React, { useEffect } from "react";
import Button from "../../../../common/ekedc-components/button/Button";
import CommonDialog from "../../../../common/components/dialog/CommonDialog";
import styles from "./not-eligible-modal.module.scss";

interface NotEligibleModalProps {
	onClose: () => void;
}

const CrossIcon: React.FC = () => (
	<svg width="22" height="22" viewBox="0 0 22 22" fill="none">
		<path d="M5.5 5.5L16.5 16.5M16.5 5.5L5.5 16.5" stroke="var(--app-primary-text)" strokeWidth="1.5" strokeLinecap="round" />
	</svg>
);

const REQUIREMENTS = [
	{
		title: "Link Your NIN",
		body: "Connect your National Identification Number (NIN) to verify your identity.",
	},
	{
		title: "Have a recent payment activity",
		body: "Make at least one electricity payment on the platform within the last 90 days",
	},
	{
		title: "Maintain stable NIN details",
		body: "Ensure your NIN details haven't been updated in the past 30 days",
	},
	{
		title: "Have a supported meter",
		body: "Confirm your meter model supports unit transfer",
	},
];

export const NotEligibleModal: React.FC<NotEligibleModalProps> = ({ onClose }) => {
	useEffect(() => {
		const onKey = (e: KeyboardEvent) => {
			if (e.key === "Escape") onClose();
		};
		document.addEventListener("keydown", onKey);
		return () => document.removeEventListener("keydown", onKey);
	}, [onClose]);

	return (
		<CommonDialog onCloseDialog={onClose} noPadding={true} borderRadius="21.67px">
			<div className={styles.modal}>
				<header className={styles.toolbar}>
					<button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Close">
						<CrossIcon />
					</button>
					<div className={styles.toolbarSpacer} />
				</header>

				<div className={styles.body}>
					<div className={styles.hero}>
						<span className={styles.sadFace} role="img" aria-label="Not eligible">🥺</span>
					</div>

					<div className={styles.intro}>
						<h2 className={styles.title}>Not Eligible for Unit Transfer</h2>
						<p className={styles.subtitle}>
							You don't currently meet the requirements to transfer units. To get started, please ensure you:
						</p>
					</div>

					<hr className={styles.divider} />

					<ol className={styles.list}>
						{REQUIREMENTS.map((req, idx) => (
							<li key={req.title} className={styles.listItem}>
								<span className={styles.itemNumber}>{String(idx + 1).padStart(2, "0")}.</span>
								<div className={styles.itemMain}>
									<span className={styles.itemTitle}>{req.title}</span>
									<span className={styles.itemBody}>{req.body}</span>
								</div>
							</li>
						))}
					</ol>

					<hr className={styles.divider} />
				</div>

				<footer className={styles.footer}>
					<Button text="Okay" onClick={onClose} />
				</footer>
			</div>
		</CommonDialog>
	);
};

export default NotEligibleModal;
